import { QueryOrderSettings, QueryPaginationSettings, TableFilterField } from '@sprinx/query-builder';
import { DefaultValue, atom, selector } from 'recoil';
import { MoleculerListResult } from '../../@sprinx/knihovka-types';
import { ApiClient } from '../../@sprinx/react-after-razzle';
import {
  ListCallParams,
  buildListQuery,
  createListInitialSettings,
} from '../../@sprinx/react-after-razzle/filteredLists';
import { GlobalStateRegister } from '../../@sprinx/react-after-razzle/stateStore';
import { apiClientState, localeState } from '../appState';

export interface CustomerDeliveryNote {
  // hrefs: {
  //   // href: string;
  //   type: string;
  // }[];
  // orderNo: string;

  extra: {
    contact: String;
    createDate: Date;
  };
  id: string;
  number: string;
}

export const deliveryNotesQuery = selector<MoleculerListResult<CustomerDeliveryNote>>({
  key: 'deliveryNotes',
  get: ({ get }) => {
    const initialState = get(deliveryNotesInitialState);
    if (initialState) {
      return initialState;
    }

    const apiClient = get(apiClientState);
    const locale = get(localeState);
    const params = get(deliveryNotesCallParamsState);
    get(deliveryNotesReloadTrigger);

    return getDeliveryNotes(apiClient, locale, params);
  },
  set: ({ set }, newValue) => {
    if (newValue instanceof DefaultValue) {
      set(deliveryNotesReloadTrigger, (n) => n + 1);
    }
  },
});

export const deliveryNotesCallParamsState = GlobalStateRegister.register(
  atom<ListCallParams>({
    key: 'deliveryNotesCallParams',
    default: createListInitialSettings({
      rowsPerPage: 10,
      orderBy: 'extra.createDate',
      orderDirection: 'desc',
    }),
  }),
);

export const deliveryNotesOrderByState = selector<QueryOrderSettings>({
  key: 'deliveryNotesOrderBy',
  get: ({ get }) => {
    const params = get(deliveryNotesCallParamsState);
    return params.order;
  },
  set: ({ set }, newValue) => {
    if (!(newValue instanceof DefaultValue)) {
      set(deliveryNotesCallParamsState, (prev) => ({
        ...prev,
        order: newValue,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }));
    }
  },
});

export const deliveryNotesPaginationState = selector<QueryPaginationSettings & { total: number }>({
  key: 'deliveryNotesPagination',
  get: ({ get }): QueryPaginationSettings & { total: number } => {
    const params = get(deliveryNotesCallParamsState);
    const queryResult = get(deliveryNotesQuery);

    return {
      page: queryResult.page || params.pagination.rowsPerPage,
      rowsPerPage: queryResult.pageSize || params.pagination.rowsPerPage,
      total: queryResult.total,
    };
  },
  set: ({ set }, newValue) => {
    if (!(newValue instanceof DefaultValue)) {
      set(deliveryNotesCallParamsState, (prev) => ({
        ...prev,
        pagination: {
          // ...prevValue.pagination,
          ...newValue,
        },
      }));
    }
  },
});

export const deliveryNotesFilterState = selector<TableFilterField<any>[]>({
  key: 'deliveryNotesFilter',
  get: ({ get }) => {
    const params = get(deliveryNotesCallParamsState);
    return (params.filter as TableFilterField<any>[]) || [];
  },
  set: ({ set }, newValue) => {
    if (!(newValue instanceof DefaultValue)) {
      const nextFilter = newValue.filter(Boolean);

      set(deliveryNotesCallParamsState, (prev) => ({
        ...prev,
        filter: nextFilter,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }));
    }
  },
});

export const deliveryNotesInitialState = GlobalStateRegister.register(
  atom<MoleculerListResult<CustomerDeliveryNote> | undefined>({
    key: 'deliveryNotesInitialState',
    default: undefined, // createListDefaultResult<deliveryNotesProduct>(),
  }),
);

export function getDeliveryNotes(
  apiClient: ApiClient,
  locale: string,
  params: ListCallParams,
): Promise<MoleculerListResult<CustomerDeliveryNote>> {
  return apiClient.get<MoleculerListResult<CustomerDeliveryNote>, Record<string, any>>(
    '/v1/documents',
    buildListQuery(params, { type: 'deliveryNote', fields: ['id', 'number', 'extra.createDate', 'extra.contact'] }),
  );
}

export const deliveryNotesReloadTrigger = atom<number>({
  key: 'deliveryNotesReloadTrigger',
  default: 0,
});
